<template>
<div>
</div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions([
      'destroyAuthDetails',
    ]),
  },
  created() {
    this.destroyAuthDetails()
      .then((response) => {
        if (response.status === 200) {
          this.$router.push('/');
        }
      })
      .catch((error) => {
        this.$router.push('/');
        // console.log('logout unsuccessful', error);
      });
  },
};
</script>

<style lang="scss">

</style>

